import { render, staticRenderFns } from "./RsaPazienteRiunioneEquipeModalViewComponent.vue?vue&type=template&id=72c798be"
import script from "./RsaPazienteRiunioneEquipeModalViewComponent.vue?vue&type=script&lang=js"
export * from "./RsaPazienteRiunioneEquipeModalViewComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports